export default __webpack_public_path__ + "static/logo-footer-25f5c11990837ec956ded7202b84f6a3.webp";